module.exports = __webpack_public_path__ + "public/images/music.dac6d23f167d872a863c5a2cb25cbae3.png";